<template>
    <el-dialog
    :title="titleTrans"
    :visible.sync="centerDialogVisible"
    @close="cancel"
  >
    <el-form ref="submitData" :model="submitData" label-width="120px" :rules="rules">
      <el-form-item v-if="clickType==0" label="角色key" prop="roleKey">
        <el-input v-if="clickType==0" v-model="submitData.roleKey" />
      </el-form-item>
      <el-form-item v-if="clickType==1" label="角色key">
        <span>{{ submitData.roleKey }}</span>
      </el-form-item>
      <el-form-item label="角色名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>
      <el-form-item label="所属应用" prop="appId">
        <el-select v-model="submitData.appId" placeholder="请选择">
          <el-option
            v-for="item in systemList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="注册是否可选" prop="isEnable">
        <el-radio-group v-model="submitData.isEnable">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>

        </el-radio-group>

      </el-form-item>
      <el-form-item label="角色描述" prop="description">
        <el-input v-model="submitData.description" />
      </el-form-item>
      <el-form-item label="角色类型" prop="roleType">
        <el-radio-group v-model="submitData.roleType">
          <el-radio :label="1">系统</el-radio>
          <el-radio :label="2">普通</el-radio>

        </el-radio-group>

      </el-form-item>

    </el-form>
    <!-- <div style="text-align:right;border-top:1px solid #E8E8E8;padding-top:8px;margin-top:60px;">
        <el-button @click="cancel" style="margin-right:8px">取消</el-button>
      <el-button type="primary"  @click="onSubmit('submitData')">确认</el-button>
     
    </div> -->
    <span
    slot="footer"
    class="dialog-footer"
  >
  <el-button @click="cancel" style="margin-right:8px">取消</el-button>
  <el-button type="primary"  @click="onSubmit('submitData')">确认</el-button>
  </span>
</el-dialog>
</template>
<script>
import { roleDetail, addRole, getSystem, roleKey } from '@/api/system'
import { lengthFifty, validateTwenty } from '@/api/validate'
export default {
  props: ['roleId', 'clickType'],
  data() {
    return {
      submitData: {
        roleKey: '',
        name: '',
        appId: '',
        isEnable: 0,
        description: '',
        roleType: 1
      },
      centerDialogVisible: true,
      rules: {
        roleKey: [{
          required: true,
          validator: this.checkoutKey,
          trigger: 'blur'
        }],
        name: [{
          required: true,
          validator: validateTwenty,
          trigger: 'change'
        }],
        appId: [{
          required: true,
          message: '必选项不能为空',
          trigger: 'change'
        }],
        isEnable: [{
          required: true,
          message: '必选项不能为空',
          trigger: 'change'
        }],
        description: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }]
      },
      systemList: [],
      flag: false,
      roles:this.roleId
    }
  },
  computed: {
    titleTrans() {
      let result = '添加角色'
      if (this.clickType==1) {
        result = '编辑角色'
      }
      return result
    }
  },
  mounted() {
    this.getSystemList()
    if (this.clickType == 1) {
      this.getRoleDetail()
    }else if(this.clickType==0){
      this.roles=null
    }
  },
  methods: {
    getRoleDetail() {
      roleDetail({
        id: this.roles
      }).then(res => {
        this.submitData.roleKey = res.data.roleKey
        this.submitData.name = res.data.name
        this.submitData.appId = res.data.appId
        if (res.data.isEnable) {
          this.submitData.isEnable = 1
        } else {
          this.submitData.isEnable = 0
        }
        this.submitData.description = res.data.description
        this.submitData.roleType=res.data.roleType
      })
    },
    addRole() {
      if (this.submitData.isEnable == 1) {
        this.submitData.isEnable = true
      } else if (this.submitData.isEnable == 0) {
        this.submitData.isEnable = false
      }
      addRole({
        id: this.roles,
        roleKey: this.submitData.roleKey,
        name: this.submitData.name,
        appId: this.submitData.appId,
        isEnable: this.submitData.isEnable,
        description: this.submitData.description,
        roleType:this.submitData.roleType
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success('提交成功')
          this.$emit('returnResult')
        } 
      })
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {   
            this.addRole()  
        } else {
          return false
        }
      })
    },
    getSystemList() {
      getSystem({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        this.systemList = res.data.items
      })
    },
    checkoutKey(rule, value, callback) {
      if (value) {
        roleKey({ roleKey: this.submitData.roleKey }).then(res => {
          if (res && res.code == 0) {
            this.flag = res.data
            if (value == '' || value == null || value == undefined) {
              callback(new Error('角色key不能为空'))
            } else if (value.length > 20) {
              callback(new Error('长度不能超过20'))
            } else if (this.flag) {
              callback(new Error('key不可以重复'))
            } else {
              callback()
            }
          }
        })
      }else{
        callback(new Error('角色key不能为空'))
      }
    },
    cancel() {
      this.$emit('returnResult')
    }
  }
}
</script>
<style lang="scss" scoped>
.el-radio{
  margin-right:40px;
  width:40px;
}
.el-select{
  width:100%;
}
/deep/[class*=" el-icon-"]{

  height:30px !important;
}
</style>
